// Shape is an IconButton-only concern: the square icon button can be a rounded
// square or a full circle. The standard Button has a single fixed corner radius.
export const IconButtonShape = {
  ROUNDED: 'rounded',
  CIRCLE: 'circle',
} as const;
export type IconButtonShape =
  (typeof IconButtonShape)[keyof typeof IconButtonShape];
